import { render, staticRenderFns } from "./hzmailread.vue?vue&type=template&id=1696c8ca&scoped=true&"
import script from "./hzmailread.vue?vue&type=script&lang=ts&"
export * from "./hzmailread.vue?vue&type=script&lang=ts&"
import style0 from "./hzmailread.vue?vue&type=style&index=0&id=1696c8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1696c8ca",
  null
  
)

export default component.exports